import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {EntityKey} from '../entity/entity';
import {RiserChartUnit} from '../riser/riser-chart-unit';
import {RiserUploadResponse} from '../riser/riser-upload-response';
import {GoogleService} from './google-service';

@Service()
export class RiserUploadService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public getTemplate(id: EntityKey): Observable<Blob> {
    let url = this.urlBase + 'risers/template/' + id.entityId + '/' + id.entityRevision;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public uploadRisers(key: EntityKey, fileBytes: Uint8Array): Observable<RiserUploadResponse> {
    let url = this.urlBase + 'risers/upload/' + key.entityId + '/' + key.entityRevision;
    let body = fileBytes;
    return this.http.post<RiserUploadResponse>(url, body, {headers: this.getPostHeaders()});
  }

  private getPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/octet-stream");
  }

  private getJsonPostHeaders(): HttpHeaders {
    return this.getRequestHeaders().set("Content-Type", "application/json");
  }

  public getRiserData(key: EntityKey): Observable<RiserChartUnit[]> {
    let url = this.urlBase + 'risers/data/' + key.entityId + '/' + key.entityRevision;
    return this.http.get<RiserChartUnit[]>(url, {headers: this.getRequestHeaders()});
  }

  public saveRiserData(key: EntityKey, units: RiserChartUnit[]): Observable<RiserUploadResponse> {
    let url = this.urlBase + 'risers/data/' + key.entityId + '/' + key.entityRevision;
    return this.http.post<RiserUploadResponse>(url, units, {headers: this.getJsonPostHeaders()});
  }

}
